/**
 * SuccessAnimation Component
 * Celebratory animation for completed actions
 */
import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';

const SuccessAnimation = ({ message = 'Success!', onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className="success-circle bg-white rounded-full p-8 shadow-2xl">
        <div className="relative">
          {/* Animated checkmark circle */}
          <div className="w-24 h-24 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center">
            <Check className="w-12 h-12 text-white checkmark-animate" strokeWidth={3} />
          </div>
          
          {/* Subtle confetti particles */}
          <div className="absolute -top-4 -left-4 w-4 h-4 rounded-full bg-indigo-400 confetti opacity-0"></div>
          <div className="absolute -top-2 -right-4 w-3 h-3 rounded-full bg-purple-400 confetti opacity-0" style={{ animationDelay: '100ms' }}></div>
          <div className="absolute -bottom-4 -left-2 w-3 h-3 rounded-full bg-pink-400 confetti opacity-0" style={{ animationDelay: '200ms' }}></div>
          <div className="absolute -bottom-2 -right-4 w-4 h-4 rounded-full bg-blue-400 confetti opacity-0" style={{ animationDelay: '150ms' }}></div>
        </div>
        
        {/* Success message */}
        <p className="text-center mt-4 text-lg font-semibold text-gray-800 fade-in-up">
          {message}
        </p>
      </div>
    </div>
  );
};

export default SuccessAnimation;
